<template>
  <v-form v-model="valid" ref="form">
    <v-container fluid class="px-6">
      <v-row>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input dense prefix="" :precision="0" :min="1" integer label="Bottles per selling unit" v-model="product.bottlesPerUnit"
                               :rules="[fieldRules.required]" :disabled="product.existingTransactions"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Low inventory point" v-model="product.lowDutyPaidInventoryBottles"
                                prefix="" suffix="bottles" :precision="0" integer no-minimum
                                hint="Alert if duty-paid inventory falls below this amount"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on sales forms" v-model="product.sellingDescription" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="4" md="3">
          <v-checkbox dense label="Commission exempt" v-model="product.dutyPaidCommissionExempt"/>
        </v-col>
      </v-row>

      <v-row dense v-if="values && connectedToAccounting">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="product.dutyPaidIncomeAccountRef" label="Income account"
                          :accounts="incomeAccounts" :addTypes="['Income']"
                          hint="The income account is used to track duty-paid sales of this product."/>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="product.dutyPaidCogAccountRef" label="Cost of goods account"
                          :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']"
                          hint="The cost of goods account is used to track duty-paid sales of this product"/>
        </v-col>
      </v-row>

      <component :is="province" :product="product" :taxes="taxes" v-model="provinceValid"/>
    </v-container>

    </v-form>
</template>

<script>
import InventoryProductsEditDutyPaidNoProvince from '@/views/inventory/products/InventoryProductsEditDutyPaidNoProvince'

export default {
  name: 'InventoryProductsEditDutyPaidSelling',
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true},
    incomeAccounts: {type:Array, required:true},
    cogAccounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true,
      provinceValid: true,
      province: null
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },

  watch: {
    product: {
      handler() {this.$emit('input', true);},
      immediate: true,
      deep: true
    }
  },
  async created() {
    if (this.product.alcoholType === 'Spirit')
      this.province = () => ({component:import(`@/views/provinces/${this.$store.getters.company.province}/product/DutyPaidSelling`),
                              error:InventoryProductsEditDutyPaidNoProvince, timeout:5000});
    else
      this.province = InventoryProductsEditDutyPaidNoProvince;
    setTimeout(() => {if (this.$refs.form) this.$refs.form.validate()},2000);
  }
}
</script>